import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Charts from "../Echarts";
import Ch from "../../../utils/default/bat_data/ChinaSales";
import Am from "../../../utils/default/bat_data/AmSales";
import Eu from "../../../utils/default/bat_data/EuSales";

import InstalledCapacity from "../../../utils/default/bat_data/InstalledCapacity";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      backgroundImage:
        " -webkit-linear-gradient(top, white,#59def4,#42c4f0, #374ab0)",
      height: "20vh",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      fontSize: "2vw",
    },
  })
);

const BatMid: React.FC = (props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      style={{
        borderLeft: "2px solid #5FF6FF",
        borderRight: "2px solid #5FF6FF",
      }}
    >
      <Grid item xs={12}>
        <div className={classes.title}>
          <div style={{ fontSize: "3vw" }}>117.384GWh</div>
          <div>2019年全球新能源动力电池装机量</div>
        </div>
      </Grid>
      <Grid item xs={4}>
        <Charts
          option={Ch}
          style={{
            height: "calc(30vh - 10px)",
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <Charts
          option={Eu}
          style={{
            height: "calc(30vh - 10px)",
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Charts
          option={Am}
          style={{
            height: "calc(30vh - 10px)",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Charts
          option={InstalledCapacity}
          style={{
            height: "39vh",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default BatMid;
